import type { NewsItem } from "../api/types";

function timeAgo(iso: string | null): string {
  if (!iso) return "";
  const d = new Date(iso).getTime();
  const diff = Date.now() - d;
  const min = Math.round(diff / 60000);
  if (min < 1) return "just now";
  if (min < 60) return `${min}m ago`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.round(h / 24)}d ago`;
}

export default function NewsList({ items }: { items: NewsItem[] }) {
  if (items.length === 0) {
    return (
      <section className="rounded-2xl border border-slate-800 bg-slate-900 p-4">
        <div className="mb-2 text-sm font-medium text-slate-300">News</div>
        <p className="text-sm text-slate-500">
          No news matched yet. RSS poll runs every 10 minutes; Marketaux polls (per-symbol) need a free API key.
        </p>
      </section>
    );
  }
  return (
    <section className="overflow-hidden rounded-2xl border border-slate-800 bg-slate-900">
      <div className="border-b border-slate-800 px-3 py-2 text-sm font-medium text-slate-300">
        News
      </div>
      <ul className="divide-y divide-slate-800">
        {items.map((n) => (
          <li key={n.id} className="px-4 py-3">
            <a href={n.url} target="_blank" rel="noopener noreferrer" className="block hover:bg-slate-800/40">
              <div className="text-sm text-slate-100">{n.title}</div>
              <div className="mt-0.5 text-[11px] text-slate-500">
                {n.source} · {timeAgo(n.published_at)}
              </div>
              {n.summary && <div className="mt-1 line-clamp-2 text-xs text-slate-400">{n.summary}</div>}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
